/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import PropTypes from "prop-types";

function NumberToPrecision({ value, errValue, digits, suffix, E, ...rest }) {
  const isNan = Number.isNaN(value);
  const isNotNumb = typeof value !== "number";
  const isNotNumbDigits = typeof digits !== "number";

  if (value === null || value === undefined) return <span>{errValue}</span>;
  if (isNan || isNotNumb || isNotNumbDigits) <span>{value}</span>;

  const fixed = digits ? Number(value.toPrecision(digits)) : Number(value);
  const collapsed = Math.abs(value) < E ? 0 : fixed;

  return (
    <span {...rest} data-tooltip={value}>
      {collapsed}
      {suffix}
    </span>
  );
}

NumberToPrecision.propTypes = {
  value: PropTypes.number,
  errValue: PropTypes.string,
  digits: PropTypes.number,
  E: PropTypes.number,
  suffix: PropTypes.string,
};

NumberToPrecision.defaultProps = {
  value: null,
  errValue: "-",
  suffix: "",
  digits: 4,
  E: 0.00001,
};

export default React.memo(NumberToPrecision);
